import { Component, Inject, OnInit } from '@angular/core';
import { AgendaTelefonica } from '@app/models/agenda-telefonica.model';
import { CDSMask } from '@app/utils/cds-mask';
import { EstadoCivil } from '@app/models/util/estado-civil';
import { ActivatedRoute, Router } from '@angular/router';
import { AgendaTelefonicaService } from '@app/services/agenda-telefonica.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ToastrService } from 'ngx-toastr';
import { ValidaDocumento } from '@app/utils/valida-documento';

@Component({
  selector: 'app-telefonica-form',
  templateUrl: './telefonica-form.component.html'
})
export class TelefonicaFormComponent implements OnInit {

  agendaTelefonica: AgendaTelefonica = new AgendaTelefonica();
  cdsMask: CDSMask = new CDSMask();
  lstEstadoCivil: EstadoCivil[];
  lstErros: string[];
  titulo: string;
  lstCidade: IdDescricao[] = [];
  validaDocumento: ValidaDocumento = new ValidaDocumento();

  aguardandoSolicitacao:boolean=false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private agendaTelefonicaService: AgendaTelefonicaService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) private toastr: ToastrService

  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit() {

    this.consultasService.consultar('CIDADE').toPromise().then(data => this.lstCidade = data);

    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Telefone' : 'Novo Telefone';

      if (!id) {
        return;
      }

      this.agendaTelefonicaService.obterPorId(id)
        .subscribe(
          data => {
            this.agendaTelefonica = data;
            this.formatarNumero();
          },
          () => this.router.navigate(['./agenda/telefonica']));

    });
  }

  formatarNumero() {
    let telefone = this.agendaTelefonica.Telefone.replace(/[^0-9]/g, '');
    let celular = this.agendaTelefonica.Celular.replace(/[^0-9]/g, '');

    if (telefone.length === 0) {
      telefone = '';
    } else if (telefone.length === 11) {
      telefone = '(' + telefone.substring(0, 2) + ') ' + telefone.substring(2, 7) + '-' + telefone.substring(6);
    } else {
      telefone = '(' + telefone.substring(0, 2) + ') ' + telefone.substring(2, 6) + '-' + telefone.substring(6);
    }
    if (celular.length === 0) {
      celular = '';
    } else if (celular.length === 11) {
      celular = '(' + celular.substring(0, 2) + ') ' + celular.substring(2, 7) + '-' + celular.substring(6);
    } else {
      celular = '(' + celular.substring(0, 2) + ') ' + celular.substring(2, 6) + '-' + celular.substring(6);
    }

    this.agendaTelefonica.Telefone = telefone;
    this.agendaTelefonica.Celular = celular;

  }

  validaDados() {
    let validadeCpfCnpj : boolean = !this.validaDocumento.validaCPF_CNPJ(this.agendaTelefonica.CPF_CNPJ) 
    && !this.agendaTelefonica.CPF_CNPJ.IsNullOrEmpty();
    let validadeTelefone : boolean = !this.validaDocumento.validaTelefone(this.agendaTelefonica.Telefone) 
    && !this.agendaTelefonica.Telefone.IsNullOrEmpty();
    let validadeCelular : boolean = !this.validaDocumento.validaCelular(this.agendaTelefonica.Celular) 
    && !this.agendaTelefonica.Celular.IsNullOrEmpty();
    
    let validadeEmail : boolean = !this.validaDocumento.validaEmail(this.agendaTelefonica.Email) 
    && !this.agendaTelefonica.Email.IsNullOrEmpty();

    if (validadeCpfCnpj) {
      this.toastr.error('Número de CPF/CNPJ Inválido');
      return false;
    } else if (validadeTelefone) {
      this.toastr.error('Número de Telefone Inválido');
      return false;
    } else if (validadeCelular) {
      this.toastr.error('Número de Celular Inválido');
      return false;
    } else if (validadeEmail) {
      this.toastr.error('E-mail Inválido');
      return false;
    } else {
      return true;
    }
  }

  onSubmit() {
    if (this.validaDados()) {
      this.aguardandoSolicitacao=true
      this.agendaTelefonicaService.gravar(this.agendaTelefonica)
         .subscribe(
          () => { this.router.navigate(['./agenda/telefonica']); },
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
            this.aguardandoSolicitacao=false
          });
    }
  }
}
